"use client";

import { useEffect } from "react";

/**
 * public/sw.js を登録するだけのコンポーネント (描画物なし)。
 *
 * 開発中は登録しない: dev では /_next/static/* がビルドごとに変わらない名前で
 * 配られることがあり、SW のキャッシュが古いチャンクを返して HMR と噛み合わない
 * ため。挙動の確認は本番ビルド (next build && next start) か dev 環境で行う。
 */
export default function ServiceWorkerRegister() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;

    // 初回描画と競合させないよう load 後に登録する
    const register = () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {
        /* 登録失敗はアプリの動作に影響しないので握りつぶす */
      });
    };
    if (document.readyState === "complete") register();
    else {
      window.addEventListener("load", register);
      return () => window.removeEventListener("load", register);
    }
  }, []);

  return null;
}
